import * as actionTypes from './auth.actionTypes';
import { getSanitizedResponse } from './auth.utils';

export const registerUserAction = (userDetails) => ({
    payload: { userDetails },
    type: actionTypes.REGISTER_USER
});

export const registerUserSuccessAction = (registerResponse) => ({
    payload: { ...registerResponse },
    type: actionTypes.REGISTER_USER_SUCCESS
});

export const registerUserFailureAction = (errorResponse) => ({
    payload: { errorResponse },
    type: actionTypes.REGISTER_USER_FAILURE
});

export const loginUserAction = (loginDetails) => ({
    payload: { loginDetails },
    type: actionTypes.LOGIN_USER
});

export const loginUserSuccessAction = (userResponse) => ({
    payload: getSanitizedResponse(userResponse),
    type: actionTypes.LOGIN_USER_SUCCESS
});

export const loginUserFailureAction = (errorResponse) => ({
    payload: { errorResponse },
    type: actionTypes.LOGIN_USER_FAILURE
});

// payload: { userId, rememberMe, loginCredentials } — userId is who the pending code belongs
// to (see verifyLoginTwoFactorAction, which needs no password); the other two carry the
// existing "remember me" behavior through to this intermediate step.
export const loginUserRequiresTwoFactorAction = (payload) => ({
    payload,
    type: actionTypes.LOGIN_USER_REQUIRES_2FA
});

export const verifyLoginTwoFactorAction = (details) => ({
    payload: { details },
    type: actionTypes.VERIFY_LOGIN_2FA
});

export const verifyLoginTwoFactorSuccessAction = (userResponse) => ({
    payload: getSanitizedResponse(userResponse),
    type: actionTypes.VERIFY_LOGIN_2FA_SUCCESS
});

export const verifyLoginTwoFactorFailureAction = (errorResponse) => ({
    payload: { errorResponse },
    type: actionTypes.VERIFY_LOGIN_2FA_FAILURE
});

export const resetLoginTwoFactorAction = () => ({
    type: actionTypes.RESET_LOGIN_2FA
});

export const logoutAction = () => ({
    type: actionTypes.LOGOUT
});
